module.exports = __webpack_public_path__ + "static/media/Check.adce303a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/InfoBox/Check.svg
 ** module id = 308
 ** module chunks = 0
 **/